// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/components/spinnerloader/index.scss
// module id = 2176
// module chunks = 13